import React from "react"

import SliderSectionTitle from "./SliderSectionTitle"
import { Color } from "../../../constants/V2/color"

import LayoutHeader, {
  LayoutHeaderProps,
} from "@components/V2/LayoutComponents/Header"

type Props = {
  sectionId: string
  heading: LayoutHeaderProps
  showSliderHeading: boolean
}

const TableSectionTitles = ({
  sectionId,
  heading,
  showSliderHeading,
}: Props) => {
  if (showSliderHeading) {
    return (
      <SliderSectionTitle
        sectionId={sectionId}
        size={heading.size}
        headingText={heading.headingText}
        subheadingText={heading.headingBodyText}
        color={heading.headingTextColor || Color.Black}
      />
    )
  }
  return <LayoutHeader {...heading} />
}

export default TableSectionTitles
